import { render, staticRenderFns } from "./OrderListParts.vue?vue&type=template&id=b15502d2&scoped=true"
import script from "./OrderListParts.vue?vue&type=script&lang=js"
export * from "./OrderListParts.vue?vue&type=script&lang=js"
import style0 from "./OrderListParts.vue?vue&type=style&index=0&id=b15502d2&prod&lang=css"
import style1 from "./OrderListParts.vue?vue&type=style&index=1&id=b15502d2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b15502d2",
  null
  
)

export default component.exports